module.exports = __webpack_public_path__ + "static/media/tapbrick-3.b4da53db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tapbrick-3.jpg
// module id = 111
// module chunks = 0